// src/shared_new/modules/ImageWithRegenerate.jsx
// Image Display with Regenerate Button Module

import React from "react";
import { Alert, AlertTitle, Box, Button } from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import PerlImage from "../components/PerlImage";
import { theme } from "../../design/theme";

const { perlColors } = theme.custom;

/**
 * ImageWithRegenerate - Product image with regenerate functionality
 *
 * @param {Object} props
 * @param {string} props.imageUrl - URL of the product image
 * @param {boolean} props.loading - Image generation loading state
 * @param {Function} props.onRegenerate - Callback when regenerate is clicked
 * @param {string} props.productName - Product name for alt text
 * @param {string} props.brandColor - Brand color for button
 * @param {number} props.height - Height of image container (default: 540)
 */
export default function ImageWithRegenerate({
  imageUrl,
  loading = false,
  onRegenerate,
  imageError = "",
  onRetryImage,
  productName = "Product",
  brandColor = "#ff6034",
  height = 540,
}) {
  const [failedUrl, setFailedUrl] = React.useState(null);
  const displayedError = imageError || (imageUrl && failedUrl === imageUrl
    ? "The product image could not be displayed. The calculated cost is unchanged."
    : "");
  return (
    <Box
      data-report-image-module="true"
      sx={{
        width: "450px",
        height: height,
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      {/* Image Display */}
      <Box sx={{ flex: 1, overflow: "hidden" }}>
        <PerlImage imageUrl={displayedError && !loading ? null : imageUrl} loading={loading}
          alt={productName} height="100%" onImageError={() => setFailedUrl(imageUrl)} />
      </Box>

      {displayedError && !loading && (
        <Alert severity="warning">
          <AlertTitle>Product image unavailable</AlertTitle>
          {displayedError}
          {onRetryImage && (
            <Button size="small" onClick={() => { setFailedUrl(null); onRetryImage(); }}
              disabled={loading} startIcon={<AutoFixHighIcon />}>
              Retry image
            </Button>
          )}
        </Alert>
      )}

      {/* Regenerate Button - Only show if image exists */}
      {/* {imageUrl && !loading && (
        <Button
          variant="outlined"
          size="small"
          onClick={onRegenerate}
          disabled={loading}
          startIcon={<AutoFixHighIcon />}
          sx={{
            textTransform: "none",
            bgcolor: brandColor,
            color: "#000000",
            fontFamily: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
            fontSize: "0.813rem",
            fontWeight: 600,
            border: "none",
            "& .MuiButton-startIcon": {
              color: "#000000",
            },
            "&:hover": {
              bgcolor: `${brandColor}e6`,
              border: "none",
            },
          }}
        >
          Regenerate Image
        </Button>
      )} */}
    </Box>
  );
}
